<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label [nzSpan]="10"  [nzRequired]="wrapper.element.required">
			{{ wrapper.element.name }}
		</nz-form-label>
		<nz-form-control [nzSpan]="10" [nzAutoTips]="wrapper.autoTips">
			<nz-select [formControlName]="toControlKey(wrapper.element)" nzPlaceHolder="Select an option"  [nzDisabled]="readonly">
				<nz-option *ngFor="let opt of wrapper.element.options" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-select [formControlName]="toControlKey(wrapper.element)" nzPlaceHolder="Select an option"  [nzDisabled]="readonly">
				<nz-option *ngFor="let opt of wrapper.element.options" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
</div>
